




































































































































/** @format */
import { Component, Mixins, Watch } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import { Getter } from 'vuex-class';
// 下拉框封装组件
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import { useRecordPageList, useRecordExport } from '@/api/discount-management/index';
import Utils from '@root/utils/common';
import moment from 'moment';
import PlateInput from '@/components/plate-input/index.vue';
import * as _ from 'lodash';
import * as routeNames from '@/views/order-management/router-names';
import { couponTypeMap } from '@/types/discount-management/dictionaries';
import CountCardSimpleGrid from '@/components/count-card/simple-grid.vue';
@Component({
  name: 'CouponUseList',
  components: { ParkingLotSearch, PlateInput, CountCardSimpleGrid }
})
export default class CouponUseList extends Mixins(TableMixin, TableWidthMixin) {
  plateInputModel = false;
  private filterParam: any = {
    parkIds: [], //选中的车场
    merchantName: '',
    types: [],
    plate: '',
    startDate: moment(new Date()).format('YYYY-MM-DD'), // 开始时间
    endDate: moment(new Date()).format('YYYY-MM-DD'), // 结束时间
    parkTypes: '',
    couponName: ''
  };
  // options = _.filter(
  //   Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.cp_merchant_coupon_coupon_type),
  //   function(o) {
  //     return o.value != '04';
  //   }
  // );
  options = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.cp_merchant_coupon_coupon_type);
  // 车场业态选项
  // @Getter('dictionaries/parkType')
  // parkTypeMap?: object
  // get parkTypeOptions(): any[] {
  //   return Utils.toLabelVal(this.parkTypeMap)
  // }
  parkTypeOptions = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.cp_merchant_biz_type);
  // options = Utils.toLabelVal(couponTypeMap)
  private tableLoading: boolean = false;
  tableData: any[] = [];
  totalCount: any[] = []; //汇总
  plateHead = '';
  plateTail = '';
  //搜索时间配置
  private onTimeChange(date: any, dateString: any) {
    let [operateTimeStart, operateTimeEnd] = dateString;
    this.filterParam.startDate = operateTimeStart;
    this.filterParam.endDate = operateTimeEnd;
  }
  get defaultTime() {
    if (this.filterParam.startDate && this.filterParam.endDate) {
      return [
        this.moment(this.filterParam.startDate, 'YYYY-MM-DD'),
        this.moment(this.filterParam.endDate, 'YYYY-MM-DD')
      ];
    } else if (this.filterParam.startDate) {
      return [this.moment(this.filterParam.startDate, 'YYYY-MM-DD')];
    } else {
      return [];
    }
  }
  set defaultTime(val: any) {}
  private moment = moment;
  private disabledDate(current: any) {
    return current && current >= moment().endOf('day');
  }
  //table列表
  get tableColums() {
    return [
      {
        title: '序号',
        width: 55,
        customRender: (text: any, record: any, index: number) => {
          if (record.isTotal === true) {
            return '合计';
          }
          return `${(this.current - 1) * this.pageSize + index + 1}`;
        }
      },
      {
        title: '所属机构',
        dataIndex: 'orgDepName',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-18' }
      },
      {
        title: '业态',
        dataIndex: 'parkType',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-18' }
      },
      {
        title: '项目名称',
        dataIndex: 'projectName',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-18' }
      },
      {
        title: '所属车场',
        dataIndex: 'parkName',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-18' }
      },
      {
        title: '商户名称',
        dataIndex: 'merchantName',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-18' }
      },
      {
        title: '停车订单号',
        dataIndex: 'orderId',
        width: 320,
        scopedSlots: { customRender: 'orderId' }
      },
      {
        title: '优惠券名称',
        dataIndex: 'name',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '优惠券类型',
        dataIndex: 'type',
        width: 200,
        customRender: (text: any) => text || '--'
      },
      {
        title: '优惠数额',
        dataIndex: 'value',
        width: 180,
        customRender: (text: any) => text || '--'
      },
      {
        title: '优惠券号',
        dataIndex: 'detailId',
        width: 320,
        customRender: (text: any) => text || '--'
      },
      {
        title: '车牌号',
        dataIndex: 'plate',
        width: 160,
        customRender: (text: any) => text || '--'
      },

      {
        title: '使用时间',
        dataIndex: 'useTime',
        width: 200,
        customRender: (text: any) => text || '--'
      },

      {
        title: '实际优惠金额',
        dataIndex: 'currDiscPrice',
        width: 220,
        scopedSlots: { customRender: 'currDiscPrice' }
      }
    ];
  }
  private showSizeChangerChange(current: any, pageSize: any) {
    this.current = current;
    this.pageSize = pageSize;
    this.fetchTableData();
  }
  //table初始化
  async fetchTableData(refresh?: any) {
    if (refresh) this.current = 1;
    if (this.tableLoading) return;
    this.tableLoading = true;
    try {
      const { parkIds, types, ...rest } = this.filterParam;
      const { status, code, msg, data } = await useRecordPageList({
        ...rest,
        types: this.filterParam.types.join(','),
        parkIds: this.filterParam.parkIds.join(','),
        page: this.current,
        pageSize: this.pageSize
      });
      const {
        datas,
        totalNum,
        durationCouponCount,
        moneyCouponCount,
        freeCouponCount,
        timeFrameCouponCount,
        discountCouponCount,
        allCouponCount,
        allTotalMoney
      } = data;
      this.total = Number(data.totalNum);
      if (datas && datas.length !== 0) {
        this.tableData = datas;
        this.tableData.push({
          currDiscPrice: `${allTotalMoney ? allTotalMoney : 0}`,
          isTotal: true
        });
      } else {
        this.tableData = [];
      }
      this.totalCount = [];
      this.totalCount.push(
        { title: '全部（张）', count: allCouponCount || 0, countColor: 'warning' },
        { title: '金额优惠（张）', count: moneyCouponCount || 0, countColor: 'primary' },
        { title: '时长优惠（张）', count: durationCouponCount || 0, countColor: 'primary' },
        { title: '单次免费（张）', count: freeCouponCount || 0, countColor: 'primary' },
        { title: '限时免费（张）', count: timeFrameCouponCount || 0, countColor: 'primary' },
        { title: '折扣优惠（张）', count: discountCouponCount || 0, countColor: 'primary' }
      );
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }
  //分页
  handleTableChange(val: any) {
    this.current = val.current;
    this.pageSize = val.pageSize;
    this.fetchTableData();
  }
  //点击搜索
  searchTable() {
    this.fetchTableData(true);
  }
  //清空table
  onTableFilterClear({ defaultParkIdList }) {
    this.plateInputModel = true;
    this.filterParam = {
      parkIds: defaultParkIdList, //选中的车场
      merchantName: '',
      types: [],
      plate: '',
      startDate: moment(new Date()).format('YYYY-MM-DD'), // 开始时间
      endDate: moment(new Date()).format('YYYY-MM-DD'), // 结束时间
      parkTypes: '',
      couponName: ''
    };
    this.searchTable();
  }
  // 车牌改变
  plateChange([plateHead, plateTail]: any, b: any) {
    this.filterParam.plate = plateHead + plateTail;
  }
  //导出
  private async downLoad() {
    try {
      const { parkIds, types, ...rest } = this.filterParam;
      await useRecordExport(
        {
          ...rest,
          types: this.filterParam.types.join(','),
          parkIds: this.filterParam.parkIds.join(','),
          currPage: this.current,
          pageSize: this.pageSize
        },
        '优惠券使用记录'
      );
    } catch (e) {
      console.log('useRecordExport', '导出失败');
    }
  }
  created() {
    this.fetchTableData();
  }
  /**
   * 跳转订单详情页面
   */
  toParkOrderDetail(obj: any) {
    const { parkId, orderId: pkOrderId } = obj;
    this.$router.push({
      name: routeNames.PARKING_RECORD_DETAIL,
      params: {
        parkId,
        pkOrderId
      }
    });
  }
}
